import {Component, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';
import {Subscription} from 'rxjs';
import {ModelViewInventaire} from '../../inventaire/model-view-inventaire';
import {LOTS_PERIMES, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {StocksService} from "../../../../core/services/gestion-stock/stocks.service";
import {GraphQLService} from "../../../../core/services/technique/graphql.service";
import {UniteDeProductionDTO} from "../../../../core/dtos/unite-de-production-dto";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {SelectOption} from "../../../../shared/ui/select-option";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-dialog-perimes',
    templateUrl: './dialog-perimes.component.html',
    styleUrls: ['./dialog-perimes.component.scss'],
    standalone: false
})
export class DialogPerimesComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  subAction: Subscription;


  displayDialog = false;
  selectedMatierePremiere: ModelViewInventaire;
  lotsArticlesLoaded: string[];

  LOTS_PERIMES = LOTS_PERIMES;

  // T = tous les périmés, S = produit sélectionné
  deleteOption = LOTS_PERIMES.DENREE_SELECTIONNEE;

  deleteOptions: SelectOption[] = [];

  dateSelected: Date;

  udpSelected: number[] = [];
  udpList: UniteDeProductionDTO[] = [];

  constructor(public utils: UtilsService,
              private stockSvc: StocksService,
              private toastSvc: ToastService,
              private auth2Svc: Auth2Service,
              private graphQlSvc: GraphQLService) {}

  ngOnInit() {
    this.subAction = this.stockSvc.openDialogPerimes$.subscribe(()=> this.displayDialog = true);

    this.initUdpList();
    this.dateSelected = new Date();
  }

  closeDialog = () => {
    this.deleteOptions = [];
    this.displayDialog = false;
  };

  ngOnDestroy(): void {
    this.deleteOptions = [];
    this.utils.unsubscribe(this.subAction);
  }

  initUdpList = () => {
    const siteIdList: number[] = this.auth2Svc.utilisateur.sites.map(s => s.id);
    return this.graphQlSvc.sendQuery(`
      {
        allUnitesProduction(filters: {
          idsSites: [${siteIdList}]
        }) {
          id,
          libelle
        }
    }`).subscribe(result => {
      if (result) {
        this.udpList = result.allUnitesProduction;
      }
    });
  }

  deletePerimes = () => {
    let lotsToDisable = this.lotsArticlesLoaded;
    if(this.deleteOption === LOTS_PERIMES.DENREE_SELECTIONNEE)
      lotsToDisable = this.selectedMatierePremiere?.children?.map(c => c.lotArticle);

    this.stockSvc.updateLotsPerimes(this.dateSelected, this.udpSelected).subscribe(response => {
      if (!this.utils.isResponseSupplierError(response)) {
        this.closeDialog();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Les lots périmés ont été enlevés du stock avec succès`);
        this.stockSvc.announceLotsDeleted();
      }
    });
  };

  changeDateSelected = ($event: any) => {
    this.dateSelected = $event.value;
  }

  onSelectionChange($event: any) {
    this.udpSelected = $event;
  }

  canDelete = (): boolean => this.udpSelected.length > 0;
}
